import { render, staticRenderFns } from "./ConsumptionDetailsComparison.vue?vue&type=template&id=4b9bd82e&scoped=true&"
import script from "./ConsumptionDetailsComparison.vue?vue&type=script&lang=js&"
export * from "./ConsumptionDetailsComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9bd82e",
  null
  
)

export default component.exports